import ReactGA from "react-ga4";

// Google Analytics 4 の測定ID
const GA_MEASUREMENT_ID = "G-8GR3DV0F3K";

// 初期化（モジュール読み込み時に一度だけ実行）
ReactGA.initialize(GA_MEASUREMENT_ID);

/**
 * ページビューを送信する
 * App.js の RouteTitleManager からルート変更のたびに呼び出される
 * @param {{ path: string, title: string }} params
 */
export function trackPageView({ path, title }) {
  ReactGA.send({
    hitType: "pageview",
    page: path,
    title: title,
  });
}
